export default "__VITE_ASSET__BGtCAdJu__"